import api from "@/api/RepositoryFactory.js";
/* eslint-disable */
const state = () => ({
    surveyDetails: {},
});

const getters = {
    getSurveyDetails: (state) => {
        return state.surveyDetails;
    },
};

const actions = {
    async fetchSurveyDetails({ commit }, surveyId) {
        try {
            const resp = await api.details.getSurveyDetails(surveyId);
            commit("SET_SURVEY_DETAILS", resp.data.result.data);
        } catch (e) {
            console.log(e);
        }
    },
};

const mutations = {
    SET_SURVEY_DETAILS(state, data) {
        state.surveyDetails = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
